const Logger = require("loglevelnext/lib/LogLevel");

export default new Logger({
    level: "silent",
    prefix: {
        template: "{{time}} {{level}}[connector] ",
    },
});
